import { compareBatchPlacementOrder } from '@tcvs/shared';
import type { ApiResult } from '../auth/api-client';
import type {
  CatalogFilters,
  CatalogListCardRecord,
  CatalogListResponse,
} from '../catalog/catalog-api';

export function positionBatchCards(
  cards: readonly CatalogListCardRecord[],
): CatalogListCardRecord[] {
  const ordered = [...new Map(cards.map((card) => [card.cardId, card])).values()]
    .filter((card) => card.retiredAt === undefined && card.placementState !== 'PULLED')
    .sort(compareBatchPlacementOrder);
  return ordered.map((card, index) => ({
    ...card,
    currentBatchPosition: index + 1,
    currentBatchSize: ordered.length,
  }));
}

export async function loadOrderedBatchCards(
  list: (filters: CatalogFilters) => Promise<ApiResult<CatalogListResponse>>,
  batchId: string,
): Promise<ApiResult<CatalogListResponse>> {
  const cards: CatalogListCardRecord[] = [];
  const seenCursors = new Set<string>();
  let lastKey: string | undefined;
  do {
    const result = await list({
      placementBatchId: batchId,
      limit: 500,
      ...(lastKey ? { lastKey } : {}),
    });
    if (!result.ok) return result;
    cards.push(...result.data.items);
    lastKey = result.data.lastKey ?? undefined;
    if (lastKey !== undefined) {
      if (seenCursors.has(lastKey)) {
        return { ok: false, error: 'batch_pagination_failed', status: 500 };
      }
      seenCursors.add(lastKey);
    }
  } while (lastKey !== undefined);
  return { ok: true, status: 200, data: { items: positionBatchCards(cards), lastKey: null } };
}
